import { css, cx } from '@/styled-system/css';

export const menuItemCX = css({
  position: 'relative',
  fontSize: 'md',
  lineHeight: 'md',
  color: 'hpxGrey600',
  _hover: {
    color: 'hpxBlue600',
    cursor: 'pointer',
  },
});

export const menuItemActiveCX = css({
  color: 'hpxBlue600',
});

export const menuItemLinkCX = css({
  position: 'relative',
  display: 'inline-block',
  fontSize: 'md',
  lineHeight: '56px',
  paddingTop: '0',
  paddingRight: '12px',
  paddingBottom: '0',
  paddingLeft: '12px',
  textDecoration: 'none!',
  _hover: {
    textDecoration: 'none!',
  },
  _active: {
    textDecoration: 'none!',
  },
  _focusVisible: {
    outlineOffset: '-1px',
    textDecoration: 'none!',
  },
});

export const getMenuItemCX = (active?: boolean) => cx(menuItemCX, active && menuItemActiveCX);
